import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, observable } from "mobx";
const DEFAULT_CHANNEL = "global";
// Single source of truth for channel identifiers — outlet and producer
// import the same constant. Add an entry per new layout slot.
const NotificationChannel = {
    accountV2Unauth: "account-v2-unauth",
    accountV2Auth: "account-v2-auth"
};
// Centralised store for inline notifications; outlets render via channel.
class NotificationStore {
    constructor(rootStore){
        this.notifications = [];
        this.nextId = 1;
        this.rootStore = rootStore;
    }
    add(input) {
        const id = `n${this.nextId++}`;
        const notification = {
            id,
            channel: input.channel ?? DEFAULT_CHANNEL,
            type: input.type,
            message: input.message,
            title: input.title,
            closable: input.closable
        };
        this.notifications = [
            ...this.notifications,
            notification
        ];
        return id;
    }
    remove(id) {
        this.notifications = this.notifications.filter((n)=>n.id !== id);
    }
    clearChannel(channel) {
        this.notifications = this.notifications.filter((n)=>n.channel !== channel);
    }
    clearAll() {
        this.notifications = [];
    }
    getByChannel(channel) {
        return this.notifications.filter((n)=>n.channel === channel);
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Array)
], NotificationStore.prototype, "notifications", void 0);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof NotificationInput === "undefined" ? Object : NotificationInput
    ]),
    _ts_metadata("design:returntype", String)
], NotificationStore.prototype, "add", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], NotificationStore.prototype, "remove", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], NotificationStore.prototype, "clearChannel", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], NotificationStore.prototype, "clearAll", null);
export { NotificationStore, NotificationChannel, DEFAULT_CHANNEL };
